export const state = {
	clientsettings: [],
	usersettings: [],
	vpsList : [],
	subscriptionList: [],
	subscriptionDetail :[],
	userOtherDetail : {},
	transactionList :[],
	cardList :[],
	getClientData : {},


	countriesList : {},
	citiesList :[],
	emailData : [],
	
	groupAdminName : {},
	userGroupId : {},
	//coupon
	couponList : [],
	sunPlanList : [],
	subExistList : [],
	subPlanDetail : [],
	
	//reporting
	reportingList : [],
	emirList : [],
	
	//email
	emailList : [],
	
	//admin
	adminList : [],
	adminDetail : [],

	notificationList : [],
	notificationDetail:[],
	notificationListOld : [],
	notificationListUnread : [],
	uploadsList: [],
	clientLeads: [],
	//ib
	iblist :[],
	ibView : [],

	ibchangelist: [],

	//client
	catList : [],
	articleList : [],
	
	userList : [],
	userView : [],
	logsList : [],
	logsView : [],
	userCount : [],

	commissionReportList : {},
	commissionWithdrawalList : {},
	commissionReportDetail : {},
	thrdPartyList : [{'key' : '01' , 'value' : 'No such risk. The Company at all times requests for Power of Attorney stating the Authorised Representative(s) of the Account'}],
	fundSrcList : {'01' : 'Client' , '02' : 'Third Party','03' : 'Anonymous'},
	idenVerList : [{'key': '01' , 'value' : 'Face to Face Identification and Verification' }, {'key':'02' ,'value': 'Non Face to Face Identification and Verification = Original or Certified True Copies of  KYC'} ,  {'key' : '03' , 'value' : 'Non Face to Face Identification and Verification - Compliance with Section 2 of Fourth Appendix of Directive = Plain Copies of Originals'}, {'key' : '04', 'value' : 'Non Face to Face Identification and Verification - NOT in compliance with Section 2 of Fourth Appendix of Directive = Plain Copies of Originals'}, {'key' : '05', 'value' : 'No KYC provided/Failed to Verify Client/Client Unwilling to Provide'}],
	genderList : {'M' : 'male' , 'F' : 'female'},
	chnlRiskList : {'01' : 'Employee/Senior Management Recommendation/Meeting' , '02' : 'Introduction from existing client whose AML Risk is Low/Medium','03' : 'Intrdocution via Tied Agent, Affiliate, Introducer, Agent','04' : 'Online, no communication, own initiative'},
	deptMethdList : {'01':'Credit Institution (Wire Transfer)','02' : 'Credit/Debit Card' , '03' : 'Financial Instritution/Payment Institution','04' : 'E-Wallet/Electronic Money','05' : 'Cash'},
	credInsList : [{'key' :'01' , 'value': 'EU/EEA Credit Institution (Regulated)' }, {'key' :'02' , 'value': 'EU/ EEA Financial Institution/Payment Institution (Regulated)'}, {'key' :'03' , 'value':  'EU/ EEA E-Wallet (Regulated)'},{'key' :'04' , 'value': 'EU/FATF - High Risk Country/Sanction List/Corruption List/Panama papers =Credit Institution/Financial Institution/Payment Institution/E-Wallet (Regulated & Unregulated)'},{'key' :'05' , 'value': 'Other 3rd Country Credit/Financial Institution/Payment Institution/E-Wallet  (Unregulated)'},{'key' :'06' , 'value':  'Other 3rd Country Credit/Financial Institution/Payment Institution/E-Wallet (Regulated)'}],
	
	stepList :  { "0":"Initiated", "1":"On Personal",   "2":'Declaration',   "3": "Documents Uploaded"},
	timeZone : {'Asia/Kolkata' : 'India' , 'Europe/Nicosia' : 'Cyprus' , 'Europe/London' : 'UK'},
	
	internalNotes : [],
	riskMetrix : [],

	//ticket
	ticketList : [],
	ticketView : [],
	ticketDocs : [],
	ticketData : [],
	
	ticketStatus: {'0' : 'open', '1' : 'doc verified', '2' : 'cancel', '3' : 'close'},
	ticketReason: {'1' : 'Document Upload' ,'2' :'Email Change' , '3' : 'Mobile Number Change'},
	ticketReasonList : [], 
	ticketReasonList1 : [], 
	department_list : [
		{'id' : '3','description' : 'Reporting Manager' , 'role' : 'RM'},
		{'id' : '4','description' : 'Back Office - Admin' , 'role' : 'BO-A'},
		{'id' : '5','description' : 'Back Office - Manager' , 'role' : 'BO-M'},
		{'id' : '6','description' : 'Back Office' , 'role' : 'BO'},
		{'id' : '7','description' : 'Accounts - Admin' , 'role' : 'AC-A'},
		{'id' : '8','description' : 'Accounts - Manager' , 'role' : 'AC-M'},
		{'id' : '9','description' : 'Accounts' , 'role' : 'AC'},
		{'id' : '10','description' : 'IT' , 'role' : 'IT'},
		{'id' : '11','description' : 'Customer Support' , 'role' : 'CS'},
		{'id' : '18','description' : 'Reporting Manager - Admin' , 'role' : 'RM-A'},
		{'id' : '19','description' : 'Reporting Manager - Manager' , 'role' : 'RM-M'},
		{'id' : '20','description' : 'RMS' , 'role' : 'RMS'},
		{'id' : '21','description' : 'RMS - Admin' , 'role' : 'RMS-A'},
		{'id' : '22','description' : 'RMS - Manager' , 'role' : 'RMS-M'},
		{'id' : '23','description' : "RM's who have authority to reply tickets" , 'role' : 'RM-R'},
		{'id' : '24','description' : 'COmpliance role' , 'role' : 'CM-A'}
	],  
	ticket_reply_pre : [
		{'name' : 'A', 'message' : 'please wait for reply'},{'name' : 'B', 'message' : 'ticket Reject'},
		{'name' : 'C', 'message' : 'please wait for rejection'},{'name' : 'D', 'message' : 'ticket approve'} 
	
	],
	
	//deposit
	depositList : [],
	depositView : [],
	depositTransactionList : [],
	depositStatus : {'-1' : 'Transaction Initiated', '0' : 'pending' ,'1' :'success', '2' :'Decilned','3':"Decilned", '4': "unverified account"},
	// depositMethod : {'1' : 'Bank' ,'2' :'Skrill', '3' : 'Neteller','4' : 'Trading Account', '5': 'Credit Card', '11': "NBP", '12':'TR', '13':'CR'},
	// depositMethod : {'1' : 'Bank' ,'2' :'Skrill', '3' : 'Neteller','4' : 'Trading Account', '5': 'Credit Card', '6': 'Giropay', '7':'Przelewy', '8':'Rapid Transfer', '9':'Nordea', '10':'Klarna', '11': 'NBP', '12':'TR', '13':'CR', '15' : 'Loyalty Transfer', '18': 'Bitcoin', '17': 'Praxis', '19' : 'LBT-Gatech', '20' : 'LBT-Payguru', '21': 'LBT-PayRetailer', '22': 'LBT-Rapid OZOW' , '26' : 'InactivityFee', '27' : 'PerformanceFeeSubscription', '28' : 'EuroBank', '29' : 'Paytoday', '30' : 'Reward', '31' : 'Alopay', '32' : 'Credit Transaction', '33' : 'PerformanceFee', '34' : 'Paymentasia', '35' : 'Bitstamp', '36' : 'Refund', '37' : 'Instant Deposit - Skrill', '38' : 'PayPal', '39' : 'Qiwi', '40' : 'Credit Card - Wirecard', '41' : 'MoneyBookers', '42' : 'Teleingreso', '43' : 'AAAFX Promo Card', '44' : 'Przelewy24', '45' : 'AutoPay', '46' : 'Instant Deposit - Wirecard', '47' : 'EPS', '48' : 'DirectPay24', '49' : 'Giropay', '50' : 'iDeal', '51' : 'Credit Card'},
	depositMethod : {'1' : 'Bank' ,'2' :'Instant Deposit - Skrill', '3' : 'Neteller','4' : 'Trading Account', '5': 'Credit Card', '6': 'Giropay', '7':'Przelewy24', '8':'Rapid Transfer', '9':'Nordea', '10':'Klarna', '11': 'NBP', '12':'TR', '13':'CR', '14' : 'FNB', '15' : 'Loyalty Transfer', '18': 'Capital Wallet', 'CapitalW-v.n-G': 'Capital Wallet', '17': 'Praxis', '19' : 'LBT-Gatech', '20' : 'LBT-Payguru', '21': 'LBT-PayRetailer', '22': 'LBT-Rapid OZOW' , '23': 'Virtual Pay', '24' : 'Help2pay', '25' : 'Perfect Money', '26' : 'EuroBank', '27' : 'PerformanceFeeSubscription', '28' : 'InactivityFee', '29' : 'Paytoday', '30' : 'Reward', '31' : 'Alopay', '32' : 'Credit Transaction', '33' : 'PerformanceFee', '34' : 'Paymentasia', '36' : 'IB Commission',  '38' : 'PayPal', '39' : 'Qiwi', '40' : 'Credit Card - Wirecard', '41' : 'MoneyBookers', '42' : 'Teleingreso', '43' : 'AAAFX Promo Card',  '45' : 'AutoPay', '46' : 'Instant Deposit - Wirecard', '47' : 'EPS', '48' : 'DirectPay24',  '50' : 'iDeal','51' : 'Bitstamp','52' : 'AstroPay ', '53': 'FAIRPAY CASH', '54': 'FAIRPAY ONLINE', '55' : 'Korapay', '56' : 'Swiffy', '57' : 'OpenPayd',"32":'Nuvei'},
	depositMethods: [],
	//bonus
	bonusList : [],
	bonusView : [],
	
	//withdrawal
	withdrawalList : [],
	withdrawalListMaker : [],
	withdrawalView : [],
	withdrawalType : {'1' : 'Withdrawal' ,'2' :'Internal Transfer','3' :'Subscription'},
	withdrawalMethods : {'1' : 'bank_transfer.png' ,'2' :'skrill.png', '3' : 'neteller.png','5': 'CreditCard.svg', '6': "Giropay.svg", '7':"przelewy-24.svg", '8': "rapid-transfer.svg", '9': 'Nordea.svg', '10': 'Klarna.svg'},
	withdrawalMethod : {'1' : 'Bank' ,'2' :'Skrill', '3' : 'Neteller','4' : 'Trading Account', '5': 'Credit Card', '6': 'Giropay', '7':'Przelewy', '8':'Rapid Transfer', '9':'Nordea', '10':'Klarna', '11': 'NBP', '12':'TR', '13':'CR', '15' : 'Loyalty Transfer', '18': 'Bitcoin', '17': 'Praxis', '19' : 'LBT-Gatech', '20' : 'LBT-Payguru', '21': 'LBT-PayRetailer', '22': 'LBT-Rapid OZOW'}, //{'1' : 'bank transfer' ,'2' :'skrill', '3' : 'neteller','4' : 'Trading Account', '5': 'Credit Card', '11': "NBP", '12':'TR', '13':'CR'},
	withdrawalMethodResponse : [],
	withdrawalStatus : {'0' : 'pending', '1':'processed', '2':'rejected', '3':'rejected'}, 
	
	//trading
	tradingList : [],
	tradingView : [],
	demoLive : {'0' : 'demo' , '1' : 'live'},
	currency : {'EUR' : 'eur.svg','USD' : 'usd.svg','GBP' : 'gbp.svg','CHF' : 'chf.svg','JPY' : 'jpy.svg','AUD' : 'aud.svg'},
	/*leverage : {'01' : '100X' , '02' : '200X' , '03' : '300X'},
	currency : {'01':'USD','02':'GBP'},
	accountType : {'01' : 'ECN'},*/   //user later

	//bonus
	bonusType : {'1' : 'Add Bonus' ,'2' :'Remove Bonus'},
	bonusStatus : {'0' : 'open' , '1' : 'processed'},
	
	//permission
	permission : [],

	//tutorials
	tutorialList :[],
	tutorialCourse :[],
	tutorialCat :[],

	//tradingeducation

	categoryList :[],
	postList: [],

	ticketDocsLink : "https://global.fxview.com:2083/get/docs?type=",
	downloadUserZip : "https://global-admin.fxview.com:2083/get/zip?id=",

	withdrawalDocsLink : "https://global-admin.fxview.com:2083/get/docs?type=",
	clientReportLink :"https://global.fxview.com:2083/get/docs?type=clientReport&id=1&doc=",
	reportDocLink :'https://global-admin.fxview.com:2083/get/report/zip?from=',

	IbUserDocsLink : "https://partners.fxview.com:2096/get/docs?type=user&id=",      //"https://dev.finvasia.com:7702/get/docs?type=user&id=",   
	IbticketDocsLink : "https://partners.fxview.com:2096/get/docs?type=ticket&id="   //"https://dev.finvasia.com:7702/get/docs?type=ticket&id=",

}


// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/state.js